import copyText from './common/copyText';
import dbClick from './common/dbClick';
import crmebAuthDirective from './crmebAuth';

export default function directive(app: any) {
    app.directive('copyText', copyText);
    app.directive('dbClick', dbClick);
    app.directive('crmebAuth', crmebAuthDirective);
}
